import React from 'react'

export default () => {
    return (
        <div className="section contact text-white text-center py-16" id="contact">
            <div className="container flex flex-col justify-around items-center">
                <h3 className="text-main text-3xl border-b border-solid border-main">Contact</h3>

                <div className="flex flex-col sm:flex-row my-12">
                    <div className="p-8">
                        <i className="fa fa-map-marker text-2xl mb-2"></i>
                        <p>Brazil, São Paulo</p>
                    </div>

                    <div className="p-8">
                        <i className="fa fa-envelope-o text-2xl mb-2"></i>
                        <p>lh.pedrosot@hotmail.com</p>
                    </div>

                    <div className="p-8">
                        <i className="fa fa-phone text-2xl mb-2"></i>
                        <p>+55 (11) 97179-4284</p>
                    </div>
                </div>

                <div>
                    <ul className="flex text-2xl">
                        <li className="px-4">
                            <a className="hover:text-main" href="https://www.facebook.com/luis.tessaro.7" target="_blank" rel="noopener noreferrer"> <i className="fab fa-facebook"></i> </a>
                        </li>
                        <li className="px-4">
                            <a className="hover:text-main" href="https://github.com/LuisTessaro" target="_blank" rel="noopener noreferrer"> <i className="fab fa-github"></i></a>
                        </li>
                        <li className="px-4">
                            <a className="hover:text-main" href="https://www.linkedin.com/in/luis-tessaro-36a712150/" target="_blank" rel="noopener noreferrer"> <i className="fab fa-linkedin"></i> </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div >
    )
}